/* import __COLOCATED_TEMPLATE__ from './captioned-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();